module.exports = __webpack_public_path__ + "img/interview.4056fb07.png";